import axios from 'axios';
import { message } from 'antd';
import { defaultLocale } from '../config';

const baseURL = process.env.REACT_APP_API_URL;

const instance = axios.create({
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use(handleRequestConfig, Promise.reject);
instance.interceptors.response.use(undefined, handleResponseError);

function handleResponseError(error) {
  try {
    if (!!error.response) {
      const { data, status } = error.response;
      if (status === 422) {
        data.data.forEach((validationErr) => message.error(validationErr.msg));
      }
      if (status === 401) {
        localStorage.removeItem('state');
        window.location.href = '/login';
      } else {
        message.error(data.message);
      }
    } else {
      message.error('Falha de comunicação. Não foi possível localizar o servidor.', 5);
      message.info('Verifique sua conexão ou tente novamente em alguns minutos.', 5);
    }
  } catch {}
  return Promise.reject(error);
}

function handleRequestConfig(config) {
  config.headers.locale = getLocale();
  const token = getToken();
  if (!!token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}

function getToken() {
  let token = null;
  try {
    token = JSON.parse(localStorage.getItem('state')).auth.token;
  } catch (e) {}
  return token;
}

function getLocale() {
  try {
    let locale = JSON.parse(localStorage.getItem('state')).profile.locale;
    if (!locale) return defaultLocale.locale;
    return locale;
  } catch (e) {
    return defaultLocale.locale;
  }
}

export default instance;
